// 課金ゲート（土台）。買い切り一本＝購入で全機能・無制限。試用＝メディア（音声/動画）3本まで無料。
// DECISIONS 2026-06-26（買い切り一本／Evermusic型3択）に合わせ、旧4ティア(can(cap))は
// 「買い切りで全解放＝can は常に true」に簡素化（呼び出し地点は資産として温存）。
// 実決済はまだ無い＝今はダミー（localStorage の購入フラグ）。ネイティブ移行時に
// StoreKit(IAP)＋Web/RevenueCat へ差し替える（isPurchased() の中身を入れ替えるだけ）。
import { db } from './db.js'

const LS_PURCHASED = 'immerso-purchased'
export const FREE_LIMIT = 3 // 無料で持てるメディア（音声/動画）の本数

// localStorage は同期読みできるので import 時点で確定（await 無しで参照できる）。
let _purchased = (() => {
  try {
    return localStorage.getItem(LS_PURCHASED) === '1'
  } catch {
    return false
  }
})()

export function isPurchased() {
  return _purchased
}

// ダミー購入の切替（開発者用／ペイウォールの購入ボタン）。変更後は reload して全ゲート再評価。
export function setPurchased(v) {
  _purchased = !!v
  try {
    localStorage.setItem(LS_PURCHASED, _purchased ? '1' : '0')
  } catch {
    /* 保存できなくても続行 */
  }
}

// 買い切りは全機能込み＝従来の can(cap) は常に true（sync 等の呼び出し地点を壊さないため温存）。
export function can() {
  return true
}

// 端末内のメディア項目数（累積カウントの初期シードに使う）。items ストア＝取り込み/DL 済みメディア。
export async function itemCount() {
  return (await (await db()).getAllKeys('items')).length
}

// 無料カウントは「累積（生涯3本）」＝取得した本数を積み上げ、削除しても減らさない
// （「最初の3本無料、以降は買い切り」。入れ替えでの無制限利用を防ぐ）。
const LS_ACQUIRED = 'immerso-acquired'
let _acquired = (() => {
  const v = parseInt(localStorage.getItem(LS_ACQUIRED) || '', 10)
  return Number.isFinite(v) ? v : null // null=未初期化（初回に既存DL数でシード）
})()
function persistAcquired() {
  try {
    localStorage.setItem(LS_ACQUIRED, String(_acquired))
  } catch {
    /* 保存できなくても続行 */
  }
}
// 初回だけ、既存の取り込み/DL 済み本数を累積の初期値にする（リリース前の手持ちを無料枠に含める）。
async function ensureAcquiredInit() {
  if (_acquired == null) {
    _acquired = await itemCount()
    persistAcquired()
  }
}

export async function acquiredCount() {
  await ensureAcquiredInit()
  return _acquired
}

// 進行中（DL/取り込み中で、まだ commit していない）の予約数。
// 「判定 → 完了して累積++」の間に複数を同時開始すると上限を超える（TOCTOUレース）ので、
// 開始時に枠を同期予約し「累積＋予約数」で判定する。
let _inflight = 0

// 1本ぶんの取り込み/DL 枠を予約。OK なら true、無料枠オーバーなら false（ペイウォールへ）。
// 成功したら commitItemSlot()、失敗/中止なら releaseItemSlot() を必ず呼ぶこと。購入済みは常に true。
export async function reserveItemSlot() {
  if (_purchased) return true
  _inflight++ // await の前に同期で確保＝同時押しでも枠を二重取りさせない
  await ensureAcquiredInit()
  if (_acquired + _inflight - 1 >= FREE_LIMIT) {
    _inflight-- // 取り消し
    return false
  }
  return true
}

// 取得成功＝累積を1つ増やして予約を解放（削除しても減らさない＝生涯カウント）。
export function commitItemSlot() {
  _acquired = (_acquired || 0) + 1
  persistAcquired()
  if (_inflight > 0) _inflight--
}

// 取得失敗/中止＝累積は増やさず予約だけ返す。
export function releaseItemSlot() {
  if (_inflight > 0) _inflight--
}

// 開発者用：無料カウントを 0 に戻す（累積方式なので削除では戻らないため、テスト用に用意）。
export function resetAcquired() {
  _acquired = 0
  persistAcquired()
}

// 項目がロック中か。取得時に付けた item.freeTier（無料枠で取得＝true / 購入中に取得＝false）で判定。
// 未購入かつ「購入中に取得した分(freeTier===false)」だけロック。freeTier 未定義の古い項目はロックしない（救済）。
export function isItemLocked(item) {
  return !_purchased && !!item && item.freeTier === false
}
